import { render, staticRenderFns } from "./tkEdit.vue?vue&type=template&id=7a230bd2&scoped=true&"
import script from "./tkEdit.vue?vue&type=script&lang=js&"
export * from "./tkEdit.vue?vue&type=script&lang=js&"
import style0 from "./tkEdit.vue?vue&type=style&index=0&id=7a230bd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a230bd2",
  null
  
)

export default component.exports